import { render } from "./HTTPRequest.vue?vue&type=template&id=51228dc2"
import script from "./HTTPRequest.vue?vue&type=script&lang=js"
export * from "./HTTPRequest.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__